/* eslint react/no-danger : 0 */
import { memo } from "react";
import { accommodationTypeShape } from "app/utils/propTypes";
import ProgressiveImg from "app/pages/.shared/ProgressiveImg.jsx";
import "./AccommodationType.scss";
import Paragraphs from "app/pages/.shared/Paragraphs";
import Typography, { TYPOGRAPHY_VARIANTS } from "app/pages/.shared/Typography/Typography";

const ROOM_IMAGE_SIZES = {
	small: { width: 768 },
	medium: { width: 978 },
	large: { height: 208, width: 581 },
	xlarge: { height: 208, width: 581 },
};

const AccommodationType = ({ label, description, photo, aera, productUri }) => {
	const superficie = aera > 0 ? `[${aera} M2]` : false;

	return (
		<div className="accommodation-type">
			<header className="accommodation-type__header">
				<Typography
					variant={TYPOGRAPHY_VARIANTS.LARGE}
					isBold
					className="accommodation-type__label"
					component="h3"
				>
					{label} {superficie}
				</Typography>
			</header>
			{photo.url && (
				<div className="accommodation-type__image">
					<ProgressiveImg
						sizes={ROOM_IMAGE_SIZES}
						src={photo.url}
						alt={photo.alt}
						thumbnail={photo.thumbnail}
						productUri={productUri}
					/>
				</div>
			)}
			<div className="accommodation-type__description">
				<Paragraphs paragraphs={description} enableHTMLFormatting />
			</div>
		</div>
	);
};

AccommodationType.propTypes = {
	...accommodationTypeShape,
};

AccommodationType.defaultProps = {
	photo: {},
};

export default memo(AccommodationType);
